module.exports = __webpack_public_path__ + "media/images/img_plus-manufacturing-bb3aa429571e33e21daa9050ed6f5e0f.png";